import { render, staticRenderFns } from "./footerHome.vue?vue&type=template&id=656ef026&scoped=true"
import script from "./footerHome.vue?vue&type=script&lang=js"
export * from "./footerHome.vue?vue&type=script&lang=js"
import style0 from "./footerHome.vue?vue&type=style&index=0&id=656ef026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656ef026",
  null
  
)

export default component.exports